import hero1Desktop from '../assets/optimized/hero-1-desktop.jpg';
import hero2Desktop from '../assets/optimized/hero-2-desktop.jpg';
import hero3Desktop from '../assets/optimized/hero-3-desktop.jpg';
import hero1Mobile from '../assets/optimized/hero-1-mobile.jpg';
import hero2Mobile from '../assets/optimized/hero-2-mobile.jpg';
import hero3Mobile from '../assets/optimized/hero-3-mobile.jpg';
import { partners as partnerCards } from './partners';

const partnerItems = partnerCards.map((item, index) => {
  const partnerTitle = `${item.primary} ${item.secondary}`.trim();

  return {
    id: `partner-fallback-${index + 1}`,
    title: partnerTitle,
    image: item.logo,
    link: item.href,
    uz: { title: partnerTitle },
    en: { title: partnerTitle }
  };
});

const bannerItems = [
  {
    id: 'banner-fallback-1',
    image: hero1Desktop,
    mobileImage: hero1Mobile,
    primaryButtonLink: '#about',
    title: 'KIUF',
    uz: {
      title: 'KIUF',
      subtitle: "Zamonaviy ta'lim va xalqaro imkoniyatlar bir makonda."
    },
    en: {
      title: 'KIUF',
      subtitle: 'Modern education and international opportunities in one place.'
    }
  },
  {
    id: 'banner-fallback-2',
    image: hero2Desktop,
    mobileImage: hero2Mobile,
    primaryButtonLink: '/partners',
    title: 'Global hamkorlik',
    uz: {
      title: 'Global hamkorlik',
      subtitle: "Janubiy Koreya va xalqaro universitetlar bilan ochiq akademik aloqa."
    },
    en: {
      title: 'Global partnership',
      subtitle: 'Open academic collaboration with South Korean and international universities.'
    }
  },
  {
    id: 'banner-fallback-3',
    image: hero3Desktop,
    mobileImage: hero3Mobile,
    primaryButtonLink: '/students',
    title: 'Talabalar markazda',
    uz: {
      title: 'Talabalar markazda',
      subtitle: "Bilim, amaliyot va rivojlanish uchun qulay muhit yaratamiz."
    },
    en: {
      title: 'Students at the center',
      subtitle: 'We build a strong environment for learning, practice, and growth.'
    }
  }
];

const statisticItems = [
  {
    id: 'statistics-fallback-students',
    title: 'Talabalar',
    count: '8500',
    icon: 'UserOutlined',
    uz: { title: 'Talabalar' },
    en: { title: 'Students' }
  },
  {
    id: 'statistics-fallback-teachers',
    title: "O'qituvchilar",
    count: '620',
    icon: 'TeamOutlined',
    uz: { title: "O'qituvchilar" },
    en: { title: 'Teachers' }
  },
  {
    id: 'statistics-fallback-programs',
    title: "Yo'nalishlar",
    count: '48',
    icon: 'ReadOutlined',
    uz: { title: "Yo'nalishlar" },
    en: { title: 'Programs' }
  },
  {
    id: 'statistics-fallback-partners',
    title: 'Hamkorlar',
    count: '32',
    icon: 'GlobalOutlined',
    uz: { title: 'Hamkorlar' },
    en: { title: 'Partners' }
  }
];

export const fallbackContentLists = Object.freeze({
  banners: bannerItems,
  partners: partnerItems,
  statistics: statisticItems
});

export const fallbackSettings = Object.freeze({
  'rector-speech': {
    active: true,
    rectorName: {
      uz: 'KIUF Rektori',
      en: 'KIUF Rector'
    },
    position: {
      uz: 'Universitet rahbariyati',
      en: 'University leadership'
    },
    title: {
      uz: 'Rektor murojaati',
      en: "Rector's address"
    },
    content: {
      uz:
        "<p>KIUF zamonaviy bilim, amaliy ko'nikma va xalqaro hamkorlikni birlashtirgan ta'lim muhitini rivojlantirishni davom ettiradi.</p><p>Talabalarimiz uchun ochiq muloqot, sifatli ta'lim va real imkoniyatlar ustuvor yo'nalish bo'lib qoladi.</p>",
      en:
        "<p>KIUF continues to strengthen an educational environment built on modern knowledge, practical experience, and international cooperation.</p><p>Open dialogue, high-quality education, and real opportunities for our students remain our main priorities.</p>"
    }
  }
});
